module.exports = __webpack_public_path__ + "img/df82098.png";